import { httpClient } from '@configs/httpclient.config';
import { AxiosResponse } from 'axios';
import { AssetModelRoot } from './types';

const URL = '/moex-propack-integrationservice/api/curves/v1/assets_list/';

export const getAssetList = (assetType: string, tradeDate: string): Promise<AxiosResponse<AssetModelRoot>> => {
    return httpClient.get(`${URL}/${assetType}/${tradeDate}`);
};
